import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO_IMAGE_META__base } from '@shared/dto/+image/meta/_base/DTO_IMAGE_META__base';
import { STATE__images } from '../STATE__images';

export const LOCAL__images_upsert_meta = (payload: DTO_IMAGE_META__base[]): PayloadAction<DTO_IMAGE_META__base[]> => ({
  type: ENUM__redux_action.IMAGES_UPSERT_META,
  payload,
});

export function INIT_LOCAL__images_upsert_meta(state: STATE__images, action: PayloadAction<DTO_IMAGE_META__base[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  const { meta_map_by_id, meta_map_by_hash_sha256_content } = state;

  for (let meta of items) {
    assert_false(meta.is_stub());

    meta_map_by_id.set(meta._id, meta);

    let meta_by_hash = meta_map_by_hash_sha256_content.get_or_create_map(meta.hash_sha256_content);
    meta_by_hash.set(meta._id, meta);
  }

  //refresh map to trigger re-render
  state.meta_map_by_id = new Map(state.meta_map_by_id);
}
